module.exports = __webpack_public_path__ + "assets/img/overlay.d51cde3b.png";